import endpoints from "../utils/endpoints"
import { Api } from "./api"
import { notificationError } from "./notification"

export async function getLocationTopology(params?: any) {
  let res = [
    {
      location: '',
      distributor: '',
      server: ''
    }
  ]

  await Api.get(endpoints.getLocationTopology, {params}).then((response) => {
    if (response.status === 200) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        res = response.data.list
      }
    } else {
      notificationError('Could not get location topology')
    }
  }).catch((err: string) => {
    notificationError('Could not get location topology')
  })

  return res
}